import { useNavigate } from 'react-router-dom';

export default function CtaSection() {
  const navigate = useNavigate();

  return (
    <section className="w-full bg-off-white py-14 md:py-20 lg:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-white rounded-2xl md:rounded-3xl p-8 md:p-12 lg:p-16 border border-gray-100 shadow-soft-xl">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-deep-navy-500 leading-tight mb-4">
              SpaProBridge ile güvenli eşleşme sürecini <span className="text-dark-teal-500">başlatın</span>
            </h2>
            <p className="text-sm md:text-base text-gray-500 max-w-xl mx-auto mb-8">
              İlk aşamada Kayseri, Antalya ve İstanbul şehirlerinde kontrollü büyüme hedeflenmektedir. Terapist veya spa işletmesi olarak hemen başvurun.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-6">
              <button
                onClick={() => navigate('/terapist-kayit')}
                className="w-full sm:w-auto px-7 py-3.5 rounded-full text-sm font-semibold text-white bg-dark-teal-500 hover:bg-dark-teal-600 transition-colors shadow-soft cursor-pointer whitespace-nowrap"
              >
                Terapist Olarak Kayıt Ol
              </button>
              <button
                onClick={() => navigate('/spa-kayit')}
                className="w-full sm:w-auto px-7 py-3.5 rounded-full text-sm font-semibold text-deep-navy-500 border-2 border-deep-navy-500 hover:bg-deep-navy-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                Spa İşletmesi Olarak Başvur
              </button>
            </div>
            <p className="text-xs text-gray-400">
              Şu anlık Kayseri, Antalya ve İstanbul'da ön kayıt alınmaktadır.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}